import { ServiceHandler } from '../utils';
import type {
  UserSignature,
  SystemSignature,
} from '../store/reducers/signatures.store';

// Request/Response types
export interface CreateUserSignatureRequest {
  name: string;
  content: string;
  isDefault: boolean;
}

export interface UpdateUserSignatureRequest {
  name: string;
  content: string;
  isDefault: boolean;
}

export interface CreateSystemSignatureRequest {
  name: string;
  content: string;
  isDefault: boolean;
  email: string;
  firstName: string;
  lastName: string;
}

export interface UpdateSystemSignatureRequest {
  name: string;
  content: string;
  isDefault: boolean;
  email: string;
  firstName: string;
  lastName: string;
}

export interface SignatureResponse {
  success: boolean;
  data: UserSignature | SystemSignature;
}

export interface SignatureListResponse {
  success: boolean;
  data: UserSignature[] | SystemSignature[];
}

export interface SignatureDeleteResponse {
  success: boolean;
  message: string;
}

// User signature API endpoints
export const getUserSignatures = ServiceHandler<unknown, UserSignature[]>({
  url: '/api/docmessage/v1/signatures',
  method: 'GET',
});

export const createUserSignature = ServiceHandler<
  CreateUserSignatureRequest,
  UserSignature
>({
  url: '/api/docmessage/v1/signatures',
  method: 'POST',
});

export const updateUserSignature = ServiceHandler<
  UpdateUserSignatureRequest,
  UserSignature
>({
  url: '/api/docmessage/v1/signatures/:id',
  method: 'PUT',
});

export const deleteUserSignature = ServiceHandler<
  unknown,
  SignatureDeleteResponse
>({
  url: '/api/docmessage/v1/signatures/:id',
  method: 'DELETE',
});

export const setDefaultUserSignature = ServiceHandler<unknown, UserSignature>({
  url: '/api/docmessage/v1/signatures/:id/default',
  method: 'PUT',
});

// System signature API endpoints (requires root:root claim)
export const getSystemSignatures = ServiceHandler<unknown, SystemSignature[]>({
  url: '/api/docmessage/v1/system/signatures',
  method: 'GET',
});

export const createSystemSignature = ServiceHandler<
  CreateSystemSignatureRequest,
  SystemSignature
>({
  url: '/api/docmessage/v1/system/signatures',
  method: 'POST',
});

export const updateSystemSignature = ServiceHandler<
  UpdateSystemSignatureRequest,
  SystemSignature
>({
  url: '/api/docmessage/v1/system/signatures/:id',
  method: 'PUT',
});

export const deleteSystemSignature = ServiceHandler<
  unknown,
  SignatureDeleteResponse
>({
  url: '/api/docmessage/v1/system/signatures/:id',
  method: 'DELETE',
});

export const setDefaultSystemSignature = ServiceHandler<
  unknown,
  SystemSignature
>({
  url: '/api/docmessage/v1/system/signatures/:id/default',
  method: 'PUT',
});

// API service wrapper
export const signaturesApi = {
  // User signatures
  getUserSignatures,
  createUserSignature,
  updateUserSignature,
  deleteUserSignature,
  setDefaultUserSignature,

  // System signatures
  getSystemSignatures,
  createSystemSignature,
  updateSystemSignature,
  deleteSystemSignature,
  setDefaultSystemSignature,
};
